export default __webpack_public_path__ + "static/mvk-cardan-3187ad1fc715d460f28381ec1c49d07b.png";